import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchMe, postMe } from '../../actions/communication';
import { useCommunication } from '../../hooks/useCommunication';
import { LoadingSpinner } from '../helpers/LoadingSpinner';
import NewMessageButton from './NewMessageButton';

const SendingAs = ({ isLoading, meData, fetchMe, postMe }) => {
  const { newMessageModal } = useCommunication();

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line
  }, []);

  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(meData.me);
  }, [meData]);

  const handleEditClick = () => {
    setIsEditing(true);
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  }

  const handleSave = () => {
    if (inputValue === '') {
      return;
    }

    if (inputValue === meData.me) {
      setIsEditing(false);
      return;
    }

    const data = {
      communication: {
        sending_as: inputValue,
      },
    }
    postMe(data);
    setIsEditing(false);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setInputValue(meData.me);
      setIsEditing(false);
    }
  };

  return(
    <div  className="row u-margin-top--base o-communication__container-from flex-container align-justify align-middle">
      <div>
        <div className="o-communication__sending-as flex-container">
          <div className="align-self-middle u-txt--bold">From:</div>
          {isEditing ? (
            <div className="o-communication__sending-as--edit margin-left-1 padding-bottom-1 flex-container align-center-middle">
              <input
                className="margin-bottom-0"
                type="text"
                value={String(inputValue)}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                autoFocus
                onBlur={handleSave}
              />
              <div className="o-communication__sending-as--button" onClick={handleSave}>
                <i className="fa fa-check" aria-hidden="true"></i>
              </div>
            </div>
          ) : (
            <div className="o-communication__sending-as--value u-txt--bold">
              {isLoading ? <LoadingSpinner/> : meData.me}
            </div>
          )}
          {!isEditing && (
            <div className="o-communication__sending-as--button" onClick={handleEditClick}>
              <i className="fa fa-pencil" aria-hidden="true"></i>
            </div>
          )}
        </div>
        <div className="u-txt--label">
          The name seen by parent/caregiver(s) when they receive your message sent via Sparkler
        </div>
      </div>
      <div>
        <NewMessageButton onClick={newMessageModal}/>
      </div>
    </div>
  );
};

SendingAs.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  meData: PropTypes.object.isRequired,
  postMe: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    meData: state.communicationMe?.data || {},
    isLoading: state.communicationMe?.loading || false,
  };
};

export default connect(mapStateToProps, { fetchMe, postMe })(SendingAs);
